// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1af63609","732":"93d0c115","977":"01b324c6"}[chunkId] + ".chunk.js";
};